import { Directive, ElementRef, EventEmitter, forwardRef, HostListener, Input, Output } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";
import * as moment from "moment";

@Directive({
    selector: "[appDateMask]",
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => DateMaskDirective),
        multi: true
    }]
})
export class DateMaskDirective implements Validator {
    @Input("appDateMask") variable: string | Date;
    @Output("appDateMaskChange") variableChange: EventEmitter<string | Date> = new EventEmitter<string | Date>();

    @Input("maxDate") maxDate: Date;
    @Input("minDate") minDate: Date;

    mask: string = "__/__/____";
    inputValue: string = "";

    constructor(private element: ElementRef) {
        this.element.nativeElement.style.direction = "ltr";
    }

    @HostListener("focus")
    onFocus() {
        if (typeof this.variable != "string") {
            this.variable = moment(this.variable).format("DD/MM/YYYY");
            this.variableChange.emit(this.variable);
        }

        if (this.variable == "" || this.variable == "Invalid date") {
            this.variable = this.mask;
            this.element.nativeElement.value = this.variable;

            this.inputValue = "";

            setTimeout(() => {
                this.element.nativeElement.setSelectionRange(0, 0);
            }, 0);
        }
        else {
            this.inputValue = this.variable;
        }
    }

    @HostListener("blur")
    onBlur() {
        const rawValue: string = (this.variable as string).replace(/\D/g, "");

        if (rawValue.length == 0) {
            this.variable = "";
        }
        else if (rawValue.length < 8) {
            if (this.inputValue) {
                this.variable = this.inputValue;
            }
            else {
                this.variable = "";
            }
        }

        this.variableChange.emit(this.variable);
        this.element.nativeElement.value = this.variable;
    }

    @HostListener("input")
    onInput() {
        const rawValue: string = (this.variable as string).replace(/\D/g, "");
        let maskedValue: string = this.mask;

        let i: number = 0;
        maskedValue = maskedValue.replace(/_/g, () => {
            const char = rawValue.charAt(i++);
            return char || "_";
        });

        this.variable = maskedValue;
        this.element.nativeElement.value = this.variable;
    }

    @HostListener("beforeinput", ["$event"])
    onBeforeInput(event: Event & { inputType: string, data: string | null }) {
        let position: number = this.element.nativeElement.selectionStart || 0;
        const isSelected: boolean = this.element.nativeElement.selectionStart != this.element.nativeElement.selectionEnd;

        if (event.inputType == "deleteContentBackward") {
            event.preventDefault();

            if (this.variable[position - 1] == "/") {
                position--;
            }

            let digitIndex: number = 0;
            for (let i = 0; i < position; i++) {
                if (/^\d$/.test(this.variable[i])) {
                    digitIndex++;
                }
            }

            let slashCount: number = 0;
            for (let i = position; i < this.element.nativeElement.selectionEnd; i++) {
                if (this.variable[i] == "/") {
                    slashCount++;
                }
            }

            if (digitIndex > 0 || isSelected) {
                const rawValue: string[] = (this.variable as string).replace(/\D/g, "").split("");
                if (isSelected) {
                    rawValue.splice(digitIndex, this.element.nativeElement.selectionEnd - position - slashCount);
                }
                else {
                    rawValue.splice(digitIndex - 1, 1);
                }

                let maskedValue: string = this.mask;

                let i: number = 0;
                maskedValue = maskedValue.replace(/_/g, () => {
                    const char = rawValue[i++];
                    return char || "_";
                });

                this.variable = maskedValue;
                this.element.nativeElement.value = this.variable;

                if (isSelected) {
                    this.element.nativeElement.setSelectionRange(position, position);
                }
                else {
                    this.element.nativeElement.setSelectionRange(position - 1, position - 1);
                }
            }
        }
        else if (event.inputType == "deleteContentForward") {
            event.preventDefault();

            if (this.variable[position] == "/") {
                position++;
            }

            let digitIndex: number = 0;
            for (let i = 0; i < position; i++) {
                if (/^\d$/.test(this.variable[i])) {
                    digitIndex++;
                }
            }

            let slashCount: number = 0;
            for (let i = position; i < this.element.nativeElement.selectionEnd; i++) {
                if (this.variable[i] == "/") {
                    slashCount++;
                }
            }

            if (digitIndex < 8 || isSelected) {
                const rawValue: string[] = (this.variable as string).replace(/\D/g, "").split("");
                if (isSelected) {
                    rawValue.splice(digitIndex, this.element.nativeElement.selectionEnd - position - slashCount);
                }
                else {
                    rawValue.splice(digitIndex, 1);
                }

                let maskedValue: string = this.mask;

                let i: number = 0;
                maskedValue = maskedValue.replace(/_/g, () => {
                    const char = rawValue[i++];
                    return char || "_";
                });

                this.variable = maskedValue;
                this.element.nativeElement.value = this.variable;

                if (isSelected) {
                    this.element.nativeElement.setSelectionRange(position, position);
                }
                else {
                    this.element.nativeElement.setSelectionRange(position, position);
                }
            }
        }
        else if (/^\d$/.test(event.data || "") && (event.inputType == "insertText" || event.inputType == "insertCompositionText")) {
            event.preventDefault();

            if (this.variable[position] == "/") {
                position++;
            }

            let digitIndex: number = 0;
            for (let i = 0; i < position; i++) {
                if (/^\d$/.test(this.variable[i])) {
                    digitIndex++;
                }
            }

            let slashCount: number = 0;
            for (let i = position; i < this.element.nativeElement.selectionEnd; i++) {
                if (this.variable[i] == "/") {
                    slashCount++;
                }
            }

            const rawValue: string[] = (this.variable as string).replace(/\D/g, "").split("");

            if (isSelected) {
                rawValue.splice(digitIndex, this.element.nativeElement.selectionEnd - position - slashCount);

                let maskedValue: string = this.mask;

                let i: number = 0;
                maskedValue = maskedValue.replace(/_/g, () => {
                    const char = rawValue[i++];
                    return char || "_";
                });

                this.variable = maskedValue;
            }

            if (digitIndex < 8 && rawValue.length < 8) {
                rawValue.splice(digitIndex, 0, event.data);

                let maskedValue: string = this.mask;

                let i: number = 0;
                maskedValue = maskedValue.replace(/_/g, () => {
                    const char = rawValue[i++];
                    return char || "_";
                });

                this.variable = maskedValue;
                this.element.nativeElement.value = this.variable;

                let newPosition = position + 1;
                if (this.variable.indexOf("_") != -1 && position > this.variable.indexOf("_")) {
                    newPosition = this.variable.lastIndexOf(this.variable.match(/\d(?!.*\d)/)[0]) + 1;
                }

                this.element.nativeElement.setSelectionRange(newPosition, newPosition);
            }
        }
        else {
            event.preventDefault();

            this.element.nativeElement.setSelectionRange(position, position);
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const value: string | Date = control.value;

        if (!value) {
            return null;
        }

        let isFormatValid: boolean = false;
        let isDateRangeValid: boolean = false;

        if (typeof value == "string") {
            isFormatValid = moment(value, "DD/MM/YYYY", true).isValid();
        }
        else if (value instanceof Date) {
            isFormatValid = moment(value).isValid();
        }

        if (isFormatValid) {
            const date: moment.Moment = moment(value, "DD/MM/YYYY", true);

            if (this.maxDate && this.minDate) {
                isDateRangeValid = date.isBetween(moment(this.minDate), moment(this.maxDate), null, "[]");
            }
            else if (this.maxDate) {
                isDateRangeValid = date.isSameOrBefore(moment(this.maxDate));
            }
            else if (this.minDate) {
                isDateRangeValid = date.isSameOrAfter(moment(this.minDate));
            }
            else {
                isDateRangeValid = true;
            }

            if (isDateRangeValid) {
                return null;
            }
            else {
                this.variable = "Invalid date";
                this.variableChange.emit(this.variable);
                this.element.nativeElement.value = this.variable;

                return { invalidDateRange: true };
            }
        }
        else {
            this.variable = "Invalid date";
            this.variableChange.emit(this.variable);
            this.element.nativeElement.value = this.variable;

            return { invalidDateFormat: true };
        }
    }
}
